module.exports = __webpack_public_path__ + "img/gm_capta1nhowdy.9c787ae.png";